import { on, signOut, currentAuthenticatedUser } from "../services/auth/authService";
import { useContext } from "react";
import * as React from "react";
import IconButton from "@mui/material/IconButton";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CloseIcon from "@mui/icons-material/Close";
import LogoutIcon from "@mui/icons-material/Logout";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import Tooltip from "@mui/material/Tooltip";
import Fab from "@mui/material/Fab";
import {
  Typography,
  Modal,
  Box,
  Grid,
  Menu,
  MenuItem,
} from "@mui/material";

import { CognitoUserContext } from "../contexts/cognitoUserContext.js";
import {
  CognitoUserSignedIn
} from "../services/user/userStatusService";
import { canViewAdminTools } from "../services/permissions";
import { useNavigate } from "react-router-dom";

export default function SignInManager() {

  const { cognitoUser, setCognitoUser } = useContext(CognitoUserContext);
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);

  // Check authentication status on mount
  React.useEffect(() => {
    async function checkAuth() {
      try {
        const user = await currentAuthenticatedUser();
        setCognitoUser(user);
        setIsAuthenticated(true);
      } catch (err) {
        setCognitoUser(null);
        setIsAuthenticated(false);
      }
    }
    checkAuth();
  }, [setCognitoUser]);

  // Listen to auth events
  React.useEffect(() => {
    const unsubscribeSignIn = on('signIn', ({ payload }) => {
      setCognitoUser(payload.data.user);
      setIsAuthenticated(true);
      setModalOpen(false);
    });

    const unsubscribeSignOut = on('signOut', () => {
      setCognitoUser(null);
      setIsAuthenticated(false);
    });

    return () => {
      unsubscribeSignIn();
      unsubscribeSignOut();
    };
  }, [setCognitoUser]);


  function getUsername() {
    try {
      return cognitoUser["username"];
    } catch (error) {
      return null;
    }
  }
  function getInitial() {
    const username = getUsername();
    try {
      return username.substring(0, 1).toUpperCase();
    } catch (error) {
      return "?";
    }
  }

  hubAuthListener(); // Listener does not get any events during refresh

  const [anchorEl, setAnchorEl] = React.useState(null);
  const menuOpen = Boolean(anchorEl);

  const [modalOpen, setModalOpen] = React.useState(false);
  // No more lines of procedural code execution in this script
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleModalOpen = () => {
    setModalOpen(true);
    handleMenuClose();
  };
  const handleModalClose = () => {
    setModalOpen(false);
  };

  async function logOut() {
    handleMenuClose();
    try {
      await signOut();
      // Auth event listener will clear cognitoUser state
    } catch (error) {
      console.error("Error signing out:", error);
    }
  }

  function handleAdminClick() {
    handleMenuClose();
    navigate('/');
    window.location.reload(); // Reload to ensure admin view renders
  }

  function hubAuthListener() {
    on("auth", (data) => {

      switch (data.event) {
        case "autoSignIn":
          handleModalClose();

          break;
        case "signIn":
          handleModalClose();


          break;
        case "signUp":

          break;
        case "signOut":
          setCognitoUser(null);

          break;
        case "signIn_failure":

          break;
        case "configured":
          break;
        default:

          break;
      }
    });
  }
  return (
    <Box>
      <Fab
        color="secondary"
        aria-label="add"
        id="basic-button"
        aria-controls={menuOpen ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={menuOpen ? "true" : undefined}
        onClick={handleClick}
        size="small"
      >
        <Tooltip title={getUsername()}>
          <Typography
            sx={{
              fontSize: 20,
            }}
          >
            {getInitial()}
          </Typography>
        </Tooltip>
      </Fab>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={handleModalOpen}
          disabled={CognitoUserSignedIn(cognitoUser)}
        >
          <Tooltip title="Sign In/Up">
            <PersonOutlineIcon />
          </Tooltip>
        </MenuItem>
        {canViewAdminTools(cognitoUser) && (
          <MenuItem onClick={handleAdminClick}>
            <Tooltip title="Administration">
              <AdminPanelSettingsIcon />
            </Tooltip>
          </MenuItem>
        )}
        <MenuItem disabled={!CognitoUserSignedIn(cognitoUser)} onClick={logOut}>
          <Tooltip title="Log Out">
            <span>
              <LogoutIcon />
            </span>
          </Tooltip>
        </MenuItem>
      </Menu>
      <Modal
        open={modalOpen}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="flex-end"
          >
            <IconButton
              sx={{ color: "white" }}
              onClick={handleModalClose}
            >
              <CloseIcon />
            </IconButton>
          </Grid>

        </Grid>
      </Modal>
    </Box>
  );
}
